import { render, staticRenderFns } from "./overdueIndex.vue?vue&type=template&id=c865e644"
import script from "./overdueIndex.vue?vue&type=script&lang=js"
export * from "./overdueIndex.vue?vue&type=script&lang=js"
import style0 from "./overdueIndex.vue?vue&type=style&index=0&id=c865e644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports